module.exports = __webpack_public_path__ + "img/ebook-cover-small.08f87fb.jpg";